module.exports = __webpack_public_path__ + "img/banner-desktop-icon.35833b5f.svg";